import { mockUser } from "../../../mocks/accountData";

interface AccountSidebarProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

const navItems = [
  { id: "bookings", label: "My Bookings", icon: "ri-calendar-check-line" },
  { id: "payments", label: "Payment Methods", icon: "ri-bank-card-line" },
  { id: "addresses", label: "Saved Addresses", icon: "ri-map-pin-line" },
  { id: "profile", label: "Profile & Settings", icon: "ri-user-settings-line" },
];

export default function AccountSidebar({ activeTab, onTabChange }: AccountSidebarProps) {
  return (
    <aside className="w-full lg:w-72 flex-shrink-0">
      {/* User card */}
      <div className="bg-white rounded-2xl thick-border cartoon-shadow p-6 mb-4">
        <div className="flex items-center gap-4 mb-5">
          <div className="w-14 h-14 rounded-full bg-cl-lime border-2 border-cl-dark flex items-center justify-center flex-shrink-0 cartoon-shadow-sm">
            <span className="text-cl-dark font-black text-lg">{mockUser.avatarInitials}</span>
          </div>
          <div className="min-w-0">
            <p className="font-black text-cl-dark text-base truncate">{mockUser.name}</p>
            <p className="text-gray-500 text-xs truncate">{mockUser.email}</p>
          </div>
        </div>

        <p className="text-gray-400 text-xs mt-1 font-semibold">
          Member since {mockUser.memberSince}
        </p>
      </div>

      {/* Navigation */}
      <nav className="bg-white rounded-2xl thick-border cartoon-shadow overflow-hidden">
        {navItems.map((item, idx) => (
          <button
            key={item.id}
            onClick={() => onTabChange(item.id)}
            className={`w-full flex items-center gap-3 px-5 py-4 text-left transition-all cursor-pointer ${
              idx < navItems.length - 1 ? "border-b-2 border-transparent" : ""
            } ${
              activeTab === item.id
                ? "bg-cl-lime text-cl-dark font-black"
                : "text-gray-600 hover:bg-gray-50 font-semibold"
            }`}
          >
            <span className={`w-8 h-8 flex items-center justify-center rounded-lg flex-shrink-0 ${
              activeTab === item.id
                ? "bg-cl-dark text-cl-lime"
                : "bg-gray-100 text-gray-500"
            }`}>
              <i className={`${item.icon} text-sm`}></i>
            </span>
            <span className="text-sm">{item.label}</span>
            {activeTab === item.id && (
              <i className="ri-arrow-right-s-line ml-auto text-cl-dark"></i>
            )}
          </button>
        ))}
      </nav>

      {/* Sign out */}
      <button className="w-full mt-4 flex items-center justify-center gap-2 py-3 rounded-2xl border-2 border-transparent text-gray-500 hover:border-red-400 hover:text-red-500 transition-all text-sm font-bold cursor-pointer">
        <i className="ri-logout-box-r-line text-sm"></i>
        Sign Out
      </button>
    </aside>
  );
}
